import { getCurrentInstance } from 'vue';

export function useAnalytics() {
  const instance = getCurrentInstance();
  const analytics = instance?.appContext.config.globalProperties.$analytics;

  return {
    events: analytics?.events ?? {},
  };
}
